"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasheetEvent = void 0;
const cell_updated_1 = require("./cell_updated");
const field_updated_1 = require("./field_updated");
const record_created_1 = require("./record_created");
const record_deleted_1 = require("./record_deleted");
const record_updated_1 = require("./record_updated");
exports.datasheetEvent = {
    // Cell
    OPEventCellUpdated: cell_updated_1.OPEventCellUpdated,
    // OPEventMemberCellAdd,
    // OPEventMemberCellUpdate,
    // field
    OPEventFieldUpdated: field_updated_1.OPEventFieldUpdated,
    // Record
    OPEventRecordDeleted: record_deleted_1.OPEventRecordDeleted,
    OPEventRecordUpdated: record_updated_1.OPEventRecordUpdated,
    OPEventRecordCommentUpdated: record_updated_1.OPEventRecordCommentUpdated,
    OPEventRecordMetaUpdated: record_updated_1.OPEventRecordMetaUpdated,
    OPEventRecordCreated: record_created_1.OPEventRecordCreated,
};
//# sourceMappingURL=index.js.map